// services/localeService.js
import { USER_SETTINGS_STORAGE_KEY } from '../constants/Soter';
import { DEFAULT_LOCALE, resolveSupportedLocale } from '../locales/localeConfig';

const LocaleService = {
	/**
	 * Gets the locale from local storage and normalizes it to a supported locale.
	 */
	getOidcLocale() {
		try {
			const storedData = JSON.parse(
				localStorage.getItem(USER_SETTINGS_STORAGE_KEY)
			);
			return resolveSupportedLocale(storedData?.locale || storedData?.language);
		} catch (e) {
			console.error('Failed to parse locale from storage', e);
		}
		return DEFAULT_LOCALE;
	},

	/**
	 * Maps an OIDC profile locale to a supported app locale.
	 */
	mapProfileToLocale(profile) {
		return resolveSupportedLocale(profile?.locale);
	},
};

export default LocaleService;
